import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '924102337240614'
let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  try {
    // Create fbq queue function before script loads
    if (!window.fbq) {
      const fbq = function () {
        fbq.callMethod
          ? fbq.callMethod.apply(fbq, arguments)
          : fbq.queue.push(arguments)
      } as any
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = fbq
      if (!window._fbq) window._fbq = fbq
    }

    // Load the Facebook Pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.onerror = () => {
      // Script blocked in preview environments
    }
    document.head.appendChild(script)

    // Init and fire PageView via SDK
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  } catch (e) {
    // Silently fail
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  try {
    if (window.fbq) {
      window.fbq('track', eventName, params)
    }
  } catch (e) {
    // Silently fail
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
  }, [])
}
